const EditorialFeature = {
  parts: [
    'container',
    'trendingGrid',
    'heroSection',
    'heroImage',
    'heroContent',
    'heroSubtitle',
    'heroTitle',
    'trendingSection',
    'trendingTitle',
    'blogSection',
    'blogContainer',
    'blogGrid',
    'blogPost',
    'blogImageContainer',
    'blogImage',
    'blogContent',
    'blogCategory',
    'blogTitle',
    'blogTags',
    'blogTag',
    'blogTagText',
    'viewAllButton'
  ],
  baseStyle: {
    container: {
      width: 'full',
      pt: {base: 4, md: 6}, // 16px mobile, 24px desktop
    },
    trendingGrid: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      gap: {base: 8, md: 20}, // 32px mobile, 80px desktop
    },
    heroSection: {
      display: 'flex',
      px: {base: 5, md: 20}, // 20px mobile, 80px desktop
      flexDirection: {base: 'column', lg: 'row'},
      gap: {base: 0, md: 0},
      maxWidth: '1440px',
      mx: 'auto',
      width: 'full',
    },
    heroImage: {
      display: 'flex',
      width: {base: 'full', lg: '66.4%'},
      justifyContent: 'center',
      alignSelf: 'stretch',
      objectFit: 'cover',
      flex: {base: 'none', lg: '0 0 66.4%'},
      aspectRatio: {base: '67/56', lg: '850/711'},
    },
    heroContent: {
      display: 'flex',
      width: {base: 'full', lg: '33.6%'},
      p: {base: 8, md: 12}, // 32px mobile, 48px desktop
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      gap: 4, // 16px
      bg: 'brandColors.secondaryBG', // #F1EDE4
      flexShrink: {base: 0, lg: '0 0 33.6%'},
      minHeight: {base: 'none', lg: '100%'},
    },
    heroSubtitle: {
      alignSelf: 'stretch',
      color: 'brandColors.primaryDarkLinen', // #8C683B
      fontFamily: 'heading',
      fontSize: {base: '12px', md: '12px'}, // 12px mobile, 12px desktop
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: {base: '2.4px', md: '2.4px'}, // 2.4px mobile, 2.4px desktop
      textTransform: 'uppercase',
    },
    heroTitle: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '20px', md: '32px'}, // 20px mobile, 32px desktop
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
      letterSpacing: {base: '0px', md: '-0.32px'}, // 0px mobile, -0.32px desktop
      mb: 0,
    },
    trendingSection: {
      display: 'flex',
      mb: {base: 8, md: 6}, // 20px mobile, 80px desktop
      px: {base: 5, md: 20},
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 3, md: 3}, // 12px
      alignSelf: 'stretch',
      maxWidth: '1440px',
      mx: 'auto',
      width: 'full',
    },
    trendingTitle: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'}, // 28px mobile, 40px desktop
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '-0.4px'}, // -0.28px mobile, -0.4px desktop
      mb: 0,
    },
    blogSection: {
      display: 'flex',
      pb: {base: 14, md: 20}, // 56px mobile, 80px desktop
      flexDirection: 'column',
      alignItems: 'center',
      gap: {base: 0, md: 12}, // 0 mobile, 48px desktop
      alignSelf: 'stretch',
    },
    blogContainer: {
      display: 'flex',
      px: {base: 0, md: 20}, // 0 mobile, 80px desktop
      alignItems: 'flex-start',
      gap: {base: 8, md: 12}, // 0 mobile, 40px desktop
      alignSelf: 'stretch',
      flexDirection: 'column',
      maxWidth: '1440px',
      mx: 'auto',
      width: 'full',
      margin: '0 auto',
    },
    blogGrid: {
      columns: {base: 1, md: 3},
      spacing: {base: 8, md: 10}, // 32px mobile, 40px desktop
      alignItems: 'flex-start',
      alignSelf: 'stretch',
    },
    blogPost: {
      display: 'flex',
      px: {base: 5, md: 0}, // 20px mobile, 0 desktop
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 6}, // 16px mobile, 24px desktop
      alignSelf: 'stretch',
      flex: '1 0 0',
      transition: 'transform 0.2s ease',
      _hover: {
        transform: 'translateY(-2px)',
      },
    },
    blogImageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'stretch',
      aspectRatio: {base: '67/60', md: '1/1'}, // Figma mobile aspect ratio
      overflow: 'hidden',
    },
    blogImage: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
    },
    blogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 2}, // 16px mobile, 8px desktop
      alignSelf: 'stretch',
    },
    blogCategory: {
      alignSelf: 'stretch',
      color: 'brandColors.primaryDarkLinen', // #8C683B
      fontFamily: 'heading',
      fontSize: {base: '10px', md: '10px'}, // 10px mobile, 10px desktop
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },
    blogTitle: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '16px', md: '20px'}, // 16px mobile, 20px desktop
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%',
      mb: 0,
    },
    blogTags: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 2, // 8px
    },
    blogTag: {
      display: 'flex',
      p: '4px 8px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 2.5, // 10px
      borderRadius: '32px',
      border: '1px solid',
      borderColor: 'brandColors.linen03', // #D6D2C5
    },
    blogTagText: {
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: '10px', md: '12px'}, // 10px mobile, 12px desktop
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
    },
    viewAllButton: {
      display: 'flex',
      height: {base: '54px', md: '54px'}, // 54px mobile, 54px desktop
      p: {base: '14px 48px', md: '14px 48px'}, // 14px 48px mobile, 14px 48px desktop
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1.5, // 6px
      borderRadius: '4px',
      bg: 'brandColors.greyscale90',
      color: 'white',
      fontFamily: 'heading',
      fontSize: {base: '14px', md: '14px'}, // 14px mobile, 14px desktop
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      margin: '0 auto',
      _hover: {
        bg: 'brandColors.greyscale80',
        transform: 'translateY(-1px)',
      },
      _active: {
        transform: 'translateY(0)',
      },
    },
  },
};

export default EditorialFeature;
